import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import FluidImage from '@utility/FluidImage/index';
import FigCaption from '@utility/FigCaption';
import Parallax from '@utility/Parallax';
import PortableText from '@utility/PortableText';
import ScrollInView from '@utility/ScrollInView/index';

const ImageDuo = ({ data: { landscapeImage, portraitImage } }) => {
  const renderFigure = (image, width) =>
    image && (
      <figure>
        <Parallax y={['-45px', '45px']}>
          <FluidImage src={image.image} maxWidth={width} />
        </Parallax>
        {image.richText && (
          <FigCaption>
            <PortableText blocks={image.richText.richText} />
          </FigCaption>
        )}
      </figure>
    );

  return (
    <ScrollInView>
      <div className="wrapper">
        <div className="row">
          <div
            className={cn(`col-12 lg:col-6`, {
              'lg-down:mb-10': !!landscapeImage?.image,
            })}
          >
            {!!landscapeImage?.image && renderFigure(landscapeImage, 1200)}
          </div>
          <div
            className={cn(`col-12 lg:col-6`, {
              'lg-down:mb-10': !!portraitImage?.image,
            })}
          >
            {!!portraitImage?.image && renderFigure(portraitImage, 1200)}
          </div>
        </div>
      </div>
    </ScrollInView>
  );
};

ImageDuo.propTypes = {
  data: PropTypes.shape({
    landscapeImage: PropTypes.object,
    portraitImage: PropTypes.object,
  }),
};

ImageDuo.defaultProps = {
  data: {
    landscapeImage: {},
    portraitImage: {},
  },
};

export default ImageDuo;
